import { initializeApp } from "firebase/app";
import { deleteToken, getToken } from "firebase/messaging";
import { getMessaging } from "firebase/messaging/sw";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, signInWithPopup };
export const messaging = getMessaging(app);

export const generateToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    console.log("Notification permission:", permission);
    if (permission === "granted") {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      

      // 🔹 Delete existing token before requesting a new one
      await deleteToken(messaging);
      

      // 🔹 Request a fresh FCM token
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_vapidKey,
        serviceWorkerRegistration: registration,
      });

      if (token) {
        
        localStorage.setItem("fcmToken", token);
        return token;

    }
  }else {
    console.log("Permission not granted");
  } 
  } catch (error) {
    console.error("Error generating token:", error);
  }
};
export const deleteTokenFn = async ()=>{
 await deleteToken(messaging);
  if('serviceWorker' in navigator){
    
    
    navigator.serviceWorker.ready.then(registration=>{
      registration.pushManager.getSubscription().then(subscription=>{
        
        
        if(subscription){
          subscription.unsubscribe();

          localStorage.removeItem('fcmToken');
          console.log('unsubscribed');
        }
        else{
           
          console.log('no subscription');

        }


  }
)


}
    )
  }
}
export const activatePremission = async () => {
  try {
    const permission = await Notification.requestPermission();
    
  } catch (error) {
    console.error("Error in Notification permission:", error);
  }
}
/*

        */
